import "./ForestryMulching.module.css";
import Header from "@/reusable_sections/Header";
import WhatIsForestryMulching from "./sections/WhatIsForestryMulching";
import HowForestryMulchingIsAchieved from "./sections/HowForestryMulchingIsAchieved";
import BenefitsOfForestryMulching from "./sections/BenefitsOfForestryMulching";
import Footer from "@/reusable_sections/Footer";
export default function ForestryMulchingPage() {
  return <div>
      <Header />
      <WhatIsForestryMulching />
      <HowForestryMulchingIsAchieved />
      <BenefitsOfForestryMulching />
      <Footer />
    </div>;
}